import { createContext, useContext, useReducer } from 'react';

const WellDoneContext = createContext(null);

export const useWellDoneContext = () => {
  const ctx = useContext(WellDoneContext);
  if (!ctx) throw new Error('useWellDoneContext doit être utilisé dans <WellDoneProvider>');
  return ctx;
};

const initialState = {
  fetchAlert: false,
  alertMessage: '',
};

function reducer(state, action) {
  switch (action.type) {
    case 'PAGE_WELL_DONE_STATES_UPDATE':
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export function WellDoneProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { ...state, dispatch };
  return <WellDoneContext.Provider value={value}>{children}</WellDoneContext.Provider>;
}
